import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Form} from 'antd';
import {layout, Button} from 'icsoc-antd-ex';
import UnionComponent from 'Components/union/unionComponent';
import tWorkTimeActions from 'Actions/systemSetting/workTime';
import TableList from './tableList';
import EditModal from './modal/editModal';

const {BaseContentMainHeader} = layout;
const FormItem = Form.Item;

class WorkTime extends UnionComponent {
  constructor(props) {
    super(props);

    this.state = {
      tableListLoading: false, // 列表loading
      isEditModalVisible: false, // 编辑弹框是否可见
    };
  }

  componentWillUnmount() {
    const {actions} = this.props;

    actions.setPageStatus({pageNum: 1, pageSize: 20});
  }

  // 设置编辑弹框显示隐藏
  setEditModalVisible = () => {
    const {isEditModalVisible} = this.state;
    const {actions} = this.props;

    this.setState(
      {
        isEditModalVisible: !isEditModalVisible,
      },
      () => {
        const {isEditModalVisible: currentIsEditModalVisible} = this.state;

        if (!currentIsEditModalVisible) {
          actions.setEditModalData({id: '', data: {}});
        }
      },
    );
  };

  render() {
    const {tableListLoading, isEditModalVisible} = this.state;
    const {login} =this.props;
    return (
      <React.Fragment>
        <BaseContentMainHeader title="工作时间">
          <Form layout="inline">
              {login.permissionsList.includes('systemSettingWorkTime.add') ? 
                <FormItem> 
                   <Button type="success" onClick={this.setEditModalVisible}>
                    <span>添加工作时间</span>
                  </Button>
                </FormItem>
              : null}
          </Form>
        </BaseContentMainHeader>

        <TableList
          loading={tableListLoading}
          setTableListLoading={this.setTableListLoading}
          getTableList={this.getTableList}
          setEditModalVisible={this.setEditModalVisible}
        />

        {isEditModalVisible ? (
          <EditModal
            getTableList={this.getTableList}
            setEditModalVisible={this.setEditModalVisible}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  systemSettingWorkTime: state.systemSettingWorkTime,
  login:state.login
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tWorkTimeActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WorkTime);
